import { IRequestContext } from '@msdyn365-commerce/core';
/**
 * The currently supported translation keys
 */
export enum TranslationKey {
    MemberPriceMessage = 'memberPriceMessage'
}
/**
 * Returns the translation for the given key and locale
 * @param key
 * @param request
 * @returns string | null
 */
export function getTranslation(key: TranslationKey, request: IRequestContext): string | null {
    if (request.app.config.translations) {
        const translation = request.app.config.translations.find((translation: any) => {
            return translation.key === key && translation.locale.toLowerCase() === request.locale.toLowerCase();
        });
        return translation ? translation.value : null;
    }
    return null;
}
